/**
 * Around the page in `App.tsx`, keyed on the tab: holds this page view's "Show last readings" choice
 * and, while it is on, the data clock the page is drawn by. The why is in `use-silence-reveal.ts`
 * and `data-clock.ts`.
 */
import { useState, type ReactNode } from 'react';
import { DataClock } from '@/lib/data-clock';
import { RevealContext, type Revealed } from '@/lib/use-silence-reveal';

export function SilenceRevealProvider({ children }: { children: ReactNode }): ReactNode {
  const [revealed, set] = useState<Revealed | null>(null);
  return (
    <RevealContext.Provider value={{ revealed, set }}>
      <DataClock.Provider value={revealed?.clock ?? null}>{children}</DataClock.Provider>
    </RevealContext.Provider>
  );
}
